import { NavSection } from './navItems';
import { SidebarNavItem } from './SidebarNavItem';
import { useUiStore } from '../../../store/ui.store';

export interface SidebarNavSectionProps {
  section: NavSection;
  onNavigate?: () => void;
}

export function SidebarNavSection({ section, onNavigate }: SidebarNavSectionProps) {
  const collapsed = useUiStore((s) => s.sidebarCollapsed);

  return (
    <>
      {collapsed ? (
        <div className="mx-2 mb-1.5 mt-3.5 border-t border-border first:mt-0 first:border-t-0" />
      ) : (
        <p className="px-2.5 pb-1 pt-3.5 text-[10.5px] font-semibold uppercase tracking-wide text-text-secondary">{section.label}</p>
      )}
      <nav>
        {section.items.map((item) => (
          <SidebarNavItem key={item.path} item={item} onNavigate={onNavigate} />
        ))}
      </nav>
    </>
  );
}
